// ============================================================================
// Roof Designer (Stufe 1) · RoofDesignerTab — eingebettete Projekt-Ansicht
// ----------------------------------------------------------------------------
// Rendert den Dachplaner direkt im Projekt-Detail-Tab (projektgebunden) und
// verlinkt die fokussierte Vollbild-Route. Stufe 1: rein In-Memory, Entwurf.
// ============================================================================
import { Link } from "react-router-dom";
import { RoofDesignerWorkspace } from "./RoofDesignerWorkspace.js";

export function RoofDesignerTab({ projectId }: { projectId: string }) {
  return (
    <div>
      <div
        className="page-header"
        style={{ marginBottom: 16, alignItems: "center" }}
      >
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 600 }}>
            Dachplaner
            <span
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "var(--color-info)",
                background: "var(--color-info-tint)",
                padding: "2px 8px",
                borderRadius: 999,
                marginLeft: 8,
                verticalAlign: "middle",
              }}
            >
              Stufe 1 · Entwurf
            </span>
          </h2>
          <div style={{ fontSize: 13, color: "var(--color-text-muted)", marginTop: 2 }}>
            Manuelles Abzeichnen, Maßstab, Modulbelegung & kWp. Keine automatische Freigabe.
          </div>
        </div>
        <Link to={`/projects/${projectId}/roof-designer`} className="btn-secondary" style={{ fontSize: 13 }}>
          Im Vollbild öffnen
        </Link>
      </div>
      <RoofDesignerWorkspace projectId={projectId} />
    </div>
  );
}
